export const states = [
  { key: "Select a State", value: "" },
  { key: "AL", value: "AL" },
  { key: "AK", value: "AK" },
  { key: "AZ", value: "AZ" },
  { key: "AR", value: "AR" },
  { key: "CA", value: "CA" },
  { key: "CO", value: "CO" },
  { key: "CT", value: "CT" },
  { key: "DE", value: "DE" },
  { key: "DC", value: "DC" },
  { key: "FL", value: "FL" },
  { key: "GA", value: "GA" },
  { key: "GU", value: "GU" },
  { key: "HI", value: "HI" },
  { key: "ID", value: "ID" },
  { key: "IL", value: "IL" },
  { key: "IN", value: "IN" },
  { key: "IA", value: "IA" },
  { key: "KS", value: "KS" },
  { key: "KY", value: "KY" },
  { key: "LA", value: "LA" },
  { key: "ME", value: "ME" },
  { key: "MD", value: "MD" },
  { key: "MA", value: "MA" },
  { key: "MI", value: "MI" },
  { key: "MN", value: "MN" },
  { key: "MS", value: "MS" },
  { key: "MO", value: "MO" },
  { key: "MT", value: "MT" },
  { key: "NE", value: "NE" },
  { key: "NV", value: "NV" },
  { key: "NH", value: "NH" },
  { key: "NJ", value: "NJ" },
  { key: "NM", value: "NM" },
  { key: "NY", value: "NY" },
  { key: "NC", value: "NC" },
  { key: "ND", value: "ND" },
  { key: "OH", value: "OH" },
  { key: "OK", value: "OK" },
  { key: "OR", value: "OR" },
  { key: "PA", value: "PA" },
  { key: "PR", value: "PR" },
  { key: "RI", value: "RI" },
  { key: "SC", value: "SC" },
  { key: "SD", value: "SD" },
  { key: "TN", value: "TN" },
  { key: "TX", value: "TX" },
  { key: "UT", value: "UT" },
  { key: "VI", value: "VI" },
  { key: "VT", value: "VT" },
  { key: "VA", value: "VA" },
  { key: "WA", value: "WA" },
  { key: "WV", value: "WV" },
  { key: "WI", value: "WI" },
  { key: "WY", value: "WY" },
];

export const statesList = [
  { key: "AL", value: "AL" },
  { key: "AK", value: "AK" },
  { key: "AZ", value: "AZ" },
  { key: "AR", value: "AR" },
  { key: "CA", value: "CA" },
  { key: "CO", value: "CO" },
  { key: "CT", value: "CT" },
  { key: "DE", value: "DE" },
  { key: "DC", value: "DC" },
  { key: "FL", value: "FL" },
  { key: "GA", value: "GA" },
  { key: "GU", value: "GU" },
  { key: "HI", value: "HI" },
  { key: "ID", value: "ID" },
  { key: "IL", value: "IL" },
  { key: "IN", value: "IN" },
  { key: "IA", value: "IA" },
  { key: "KS", value: "KS" },
  { key: "KY", value: "KY" },
  { key: "LA", value: "LA" },
  { key: "ME", value: "ME" },
  { key: "MD", value: "MD" },
  { key: "MA", value: "MA" },
  { key: "MI", value: "MI" },
  { key: "MN", value: "MN" },
  { key: "MS", value: "MS" },
  { key: "MO", value: "MO" },
  { key: "MT", value: "MT" },
  { key: "NE", value: "NE" },
  { key: "NV", value: "NV" },
  { key: "NH", value: "NH" },
  { key: "NJ", value: "NJ" },
  { key: "NM", value: "NM" },
  { key: "NY", value: "NY" },
  { key: "NC", value: "NC" },
  { key: "ND", value: "ND" },
  { key: "OH", value: "OH" },
  { key: "OK", value: "OK" },
  { key: "OR", value: "OR" },
  { key: "PA", value: "PA" },
  { key: "PR", value: "PR" },
  { key: "RI", value: "RI" },
  { key: "SC", value: "SC" },
  { key: "SD", value: "SD" },
  { key: "TN", value: "TN" },
  { key: "TX", value: "TX" },
  { key: "UT", value: "UT" },
  { key: "VI", value: "VI" },
  { key: "VT", value: "VT" },
  { key: "VA", value: "VA" },
  { key: "WA", value: "WA" },
  { key: "WV", value: "WV" },
  { key: "WI", value: "WI" },
  { key: "WY", value: "WY" },
];

export const Domain_URL = "https://api.suntendispensary.com/";
export const Fullscript_Public_key =
  "YmMctarmqqYTyBOV-mYX2RRDKFhGGlS96az0f-4JehI";
export const Fullscript_OAuth_Url =
  "https://us-snd.fullscript.io/oauth/authorize?client_id=YmMctarmqqYTyBOV-mYX2RRDKFhGGlS96az0f-4JehI&redirect_uri=https%3A%2F%2Fdevapp.myherbalpharmacy.com%2Fapp%2Ffullscript";
export const Fullscript_Env = "us-snd";
export const BUCKET_NAME = "sunten-prod-bucket";
